import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../Layout";
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import { saveAs } from "file-saver";
import "dayjs/locale/ja";
import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import googleAnalytics from "fuction/googleAnalytics";
dayjs.locale("ja");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    marginLeft: "5px",
  },
  datePicker: {
    width: "105px",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  anchor: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(1),
    textDecoration: "underline",
  },
  dlbtn: {
    paddingTop:"16px",
    paddingLeft:"10px",
  }
}));

export default function DataDownload(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [all, setAll] = React.useState(false);
  const [months, setMonths] = React.useState([]);
  const [days, setDays] = React.useState([]);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [isdisable, setIsdisable] = React.useState(false);

  const messages = message();
  const minDate = dayjs().subtract(3, "month");
  const maxDate = dayjs();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - データダウンロード";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }

    request({
      method: "GET",
      url: `data/:account_id/download/${auth.state.activeGroup}`,
    }).then((data) => {
      // setKeywords(data.data);
      // setTotalCount(data.meta.total_count);
      setAll(data.data.all.enable);
      setDays(data.data.day);
      setMonths(data.data.month);
      setFromDate(data.data.range.label[0]);
      setToDate(data.data.range.label[1]);
    });
  }, [auth.state.activeGroup]);

  const handleAll = () => {
    fetchZip("all", {});
  };

  const handleRange = () => {
    fetchCsv("range", {
      range: [
        dayjs(fromDate).format("YYYY-MM-DD"),
        dayjs(toDate).format("YYYY-MM-DD"),
      ],
    });
  };

  const handleMonth = (date) => {
    fetchZip("month", { date: date });
  };

  const handleDate = (date) => {
    fetchZip("date", { date: date });
  };

  const fetchCsv = (fileName, params) => {
    const groupName = auth.state.groups.find(
      (group) => auth.state.activeGroup === group.id
    ).name;
    request({
      method: "POST",
      url: `data/:account_id/download/${auth.state.activeGroup}`,
      responseType: "blob",
      headers: { Accept: "application/csv" },
      data: params,
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/csv",
      });
      // データがあればcsvダウンロード
      if (blob.size > 0) {
        saveAs(blob, 
          `${groupName}-${(params.range[0]).replace(/-/g, "")}-` + 
          `${(params.range[1]).replace(/-/g, "")}.csv`
        );
      } else {
        alert(messages.errorMsg.blobSizeZero);
      }
    });
  };

  const fetchZip = (fileName, params) => {
    const groupName = auth.state.groups.find(
      (group) => auth.state.activeGroup === group.id
    ).name;
    request({
      method: "POST",
      url: `data/:account_id/download/${auth.state.activeGroup}`,
      responseType: "arraybuffer",
      headers: { Accept: "application/zip" },
      data: params,
    }).then((data) => {
      const blob = new Blob([data], {
        type: "application/zip",
      });
      saveAs(blob, `${groupName}.zip`);
    });
  };

  const dateValidation = (date, type) => {
    // 入力内容が日付として正しいかチェック
    if (dayjs(date, "YYYY/MM/DD").isValid()) {
      if (type == "from") {
        const toDateTime = dayjs(toDate).format("YYYY-MM-DD 00:00:00")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
        // 終了日付が開始日付より後の日かチェック
        if ((dayjs(toDateTime).isSameOrAfter(dayjs(selectedDateTime)))){
          setFromDate(dayjs(date));
          setIsdisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      } else if (type == "to"){
        const fromDateTime = dayjs(fromDate).format("YYYY-MM-DD 00:00:00")
        const selectedDateTime = dayjs(date).format("YYYY-MM-DD 00:00:00")
        // 開始日付が終了日付より前の日かチェック
        if ((dayjs(fromDateTime).isSameOrBefore(dayjs(selectedDateTime)))) {
          setToDate(dayjs(date));
          setIsdisable(false);
        } else {
          alert(messages.validation.dateRang);
        }
      }
      return;
    }
    setIsdisable(true);
    return;
  }

  const dateError = (error, value) => {
    if (error) {
      setIsdisable(true);
    }
    return;
  }

  return (
    <Layout
      content={
        <Grid container spacing={3}>
          <List>
            <ListItem>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography variant="h6">
                      期間を指定
                    </Typography>
                    <Typography variant="subtitle2" className={classes.subtitle}>
                      ※期間内のデータを1ファイルで作成しダウンロードできます。
                    </Typography>
                    <Typography variant="subtitle2" className={classes.subtitle}>
                      ※データの保存期間は過去3ヶ月分です。
                    </Typography>
                  </React.Fragment>
                }
                secondary={
                  <React.Fragment>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <Grid container>
                        <DatePicker
                          format="yyyy/MM/dd"
                          margin="normal"
                          value={fromDate}
                          minDate={minDate}
                          minDateMessage={
                            (messages.validation.minDate).replace(
                              "$1", 
                              minDate.format("YYYY-MM-DD")
                            )
                          }
                          maxDate={maxDate}
                          maxDateMessage={
                            (messages.validation.maxDate).replace(
                              "$1", 
                              maxDate.format("YYYY-MM-DD")
                            )
                          }
                          onError={(error, value) => dateError(error, value)}
                          onChange={(date) => dateValidation(date, "from")}
                          className={classes.datePicker}
                        />
                        <div className={classes.divider}>〜</div>
                        <DatePicker
                          format="yyyy/MM/dd"
                          margin="normal"
                          value={toDate}
                          minDate={minDate}
                          minDateMessage={
                            (messages.validation.minDate).replace(
                              "$1", 
                              minDate.format("YYYY-MM-DD")
                            )
                          }
                          maxDate={maxDate}
                          maxDateMessage={
                            (messages.validation.maxDate).replace(
                              "$1", 
                              maxDate.format("YYYY-MM-DD")
                            )
                          }
                          onError={(error, value) => dateError(error, value)}
                          onChange={(date) => dateValidation(date, "to")}
                          className={classes.datePicker}
                        />
                        <div className={classes.dlbtn}>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={isdisable}
                            onClick={handleRange}
                          >
                            ダウンロード
                          </Button>
                        </div>
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </React.Fragment>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography variant="h6">
                      全期間一括
                    </Typography>
                    <Typography variant="subtitle2" className={classes.subtitle}>
                      ※全期間分の日毎のファイルを一括で圧縮してダウンロードできます。
                    </Typography>
                  </React.Fragment>
                }
                secondary={
                  <Button color="primary" disabled={!all} onClick={handleAll}>
                    全期間
                  </Button>
                }
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography variant="h6">
                      月別
                    </Typography>
                    <Typography variant="subtitle2" className={classes.subtitle}>
                      ※該当月分の日毎のファイルを一括で圧縮してダウンロードできます。
                    </Typography>
                  </React.Fragment>
                }
                secondary={
                  <Grid container>
                    {months.map((month) => {
                      return (
                        <Button
                          color="primary"
                          key={month.label}
                          disabled={!month.enable}
                          onClick={() => handleMonth(month.params.date)}
                        >
                          {month.label}
                        </Button>
                      );
                    })}
                  </Grid>
                }
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="日別"
                secondary={
                  <Grid container>
                    {days.map((day) => {
                      return (
                        <Button
                          color="primary"
                          key={day.label}
                          disabled={!day.enable}
                          onClick={() => handleDate(day.params.date)}
                        >
                          {day.label}
                        </Button>
                      );
                    })}
                  </Grid>
                }
              />
            </ListItem>
            <Divider />
          </List>
        </Grid>
      }
    />
  );
}
